export default __webpack_public_path__ + "static/media/feature3-2.f1b3cb92.png";